import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { crudActionCreatorsGenerator } from './crud_action_creators_generator';

export const PROBLEM_TYPES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PROBLEM_TYPES');
export const PROBLEM_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PROBLEM_TYPES_CRUD_ACTION_CONSTANTS
);
